import { TablesDiffColorsConfig } from '@web/config';
import { diffComparisonType, diffDeltaUnit } from '@workalizer/shared/types';
import { formatDiffComparisonValue } from '@workalizer/shared/utils';
export var resolveDiffComparisonType = function (diffValue, arrowColor) {
    if (diffValue.comparisonType) {
        return diffValue.comparisonType;
    }
    if (arrowColor === TablesDiffColorsConfig.BLUE) {
        return diffComparisonType.teamAverage;
    }
    return diffComparisonType.previousPeriod;
};
export var buildDiffTooltipText = function (diffValue, t, options) {
    var _a;
    if (!diffValue) {
        return '';
    }
    var comparisonValue = formatDiffComparisonValue(diffValue);
    if (comparisonValue !== undefined) {
        var comparisonType = resolveDiffComparisonType(diffValue, options === null || options === void 0 ? void 0 : options.arrowColor);
        var comparisonTypeLabel = comparisonType === diffComparisonType.teamAverage
            ? t('badgeDiff.teamAverage')
            : t('badgeDiff.previousPeriod');
        var tooltip = t('badgeDiff.comparisonTooltip', {
            diff: (_a = diffValue.diffString) !== null && _a !== void 0 ? _a : "".concat(diffValue.diff, "%"),
            comparisonType: comparisonTypeLabel,
            value: comparisonValue
        });
        if (diffValue.deltaUnit === diffDeltaUnit.percentagePoints) {
            return "".concat(tooltip, " ").concat(t('badgeDiff.percentagePointsHint'));
        }
        return tooltip;
    }
    if (!(options === null || options === void 0 ? void 0 : options.arrowColor))
        return '';
    if (options.arrowColor === TablesDiffColorsConfig.GREEN) {
        return t('badgeDiff.previousPeriodComparison');
    }
    if (options.arrowColor === TablesDiffColorsConfig.BLUE) {
        return t('badgeDiff.teamAverageComparison');
    }
    return '';
};
